/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Text
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportTextForm } from 'labstep-web/components/FilterPost/NewIndex/Text/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostReportTextProps } from './types';

export const FilterPostReportText: React.FC<
  FilterPostReportTextProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  replace,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy="components/FilterPost/Report/Text"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportTextForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        replace={replace}
      />
    )}
    {...rest}
  />
);
